import { AdyenInstance } from "./use-adyen-instance";
import { AdyenStyleObject } from "./customization/style-object";
import { AdyenAriaLabels } from "./customization/aria-labels";
import { AdyenInstanceControls } from "./types";
import { PaymentMethodOptions } from "@adyen/adyen-web/dist/types/types";

export function createSecuredFields(
  instance: AdyenInstance["underlying"],
  supportedBrands: Array<string>,
  styleObject: AdyenStyleObject,
  ariaLabels: AdyenAriaLabels,
  controls: AdyenInstanceControls,
) {
  const opts: PaymentMethodOptions<"securedfields"> = {
    type: "card",
    brands: supportedBrands,
    styles: styleObject,
    ariaLabels: ariaLabels,
    ...controls,
  };

  return instance.create<"securedfields">("securedfields", opts);
}
